import WaveHeroBackground from "@/components/WaveHeroBackground";
const HomeHero = () => {
  return (
    <section className="relative pt-8 sm:pt-8 md:pt-6 lg:pt-6 pb-16">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center pt-4 sm:pt-6">
          <h2 className="font-header text-2xl md:text-5xl font-bold text-[#2C003E] mb-2">
            A PLACE WHERE YOUNG HEARTS GROW
          </h2>
        </div>
      </div>
      <WaveHeroBackground maskId="home-wave-mask" />
    </section>
  );
};

export default HomeHero;
